export enum ProcessType {
  Department = 'department',
  Central = 'central',
  Integration = 'integration'
}
